import {DiTime} from 'app/blocks/util/di-time';
import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IDriverType extends IBaseEntity {
    id?: number;
    description?: string;
    dayOrNight?: boolean;
    startTime?: DiTime;
    endTime?: DiTime;
    monday?: boolean;
    tuesday?: boolean;
    wednesday?: boolean;
    thursday?: boolean;
    friday?: boolean;
    saturday?: boolean;
    sunday?: boolean;
}

/**
 * Object to represent a driver's working week.
 */
export class DriverType extends BaseEntity implements IDriverType {
    public id?: number;
    public description?: string;
    public dayOrNight?: boolean;
    public startTime?: DiTime;
    public endTime?: DiTime;
    public monday?: boolean;
    public tuesday?: boolean;
    public wednesday?: boolean;
    public thursday?: boolean;
    public friday?: boolean;
    public saturday?: boolean;
    public sunday?: boolean;

    constructor(driverType?: any) {
        super();
        if (driverType) {
            this.id = driverType.id;
            this.description = driverType.description;
            this.startTime = driverType.startTime ? DiTime.newInstance(driverType.startTime) : driverType.startTime;
            this.endTime = driverType.endTime ? DiTime.newInstance(driverType.endTime) : driverType.endTime;
            this.monday = driverType.monday;
            this.tuesday = driverType.tuesday;
            this.wednesday = driverType.wednesday;
            this.thursday = driverType.thursday;
            this.friday = driverType.friday;
            this.saturday = driverType.saturday;
            this.sunday = driverType.sunday;
            this.dayOrNight = driverType.dayOrNight;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): DriverType {
        return new DriverType(this);
    }
}
